module.exports = __webpack_public_path__ + "img/logo.69f9506.png";